import { Brand } from './Brand';
export function getBrandFromHostname() {
    if (typeof window === 'undefined')
        return Brand.Lendi;
    var hostname = window.location.hostname;
    // lendi customer
    if (hostname === 'www.lendi.com.au' ||
        hostname === 'www.lendi-preprod.net' ||
        hostname === 'www.lendi-stg.net' ||
        hostname === 'www.lendi-dev.net') {
        return Brand.Lendi;
    }
    // domain customer
    if (hostname === 'www.domain.com.au' || hostname === 'stage.domain.com.au' || hostname === 'dlf.lendi-paas-dev.net') {
        return Brand.Domain;
    }
    // domain team
    if (hostname === 'team-dlf.lendi.com.au' ||
        hostname === 'team-dlf.lendi-paas-preprod.net' ||
        hostname === 'team-dlf.lendi-paas-stg.net' ||
        hostname === 'team-dlf.lendi-paas-dev.net' ||
        hostname === 'team-dlf.lendi-dev.net' ||
        hostname === 'team-dlf.lendi-stg.net' ||
        hostname === 'team-dlf.lendi.com.au.local') {
        return Brand.Domain;
    }
    // aussie customer
    if (hostname === 'www.aussie.com.au' ||
        hostname === 'www.aussie-preprod.com.au' ||
        hostname === 'www.aussie-dev.com.au' ||
        hostname === 'www.aussie-stg.com.au' ||
        hostname === 'www.aussie-dev.com.au.local') {
        return Brand.Aussie;
    }
    // aussie team
    if (hostname === 'team.aussie.com.au' ||
        hostname === 'team.aussie-preprod.com.au' ||
        hostname === 'team.aussie-dev.com.au' ||
        hostname === 'team.aussie-stg.com.au' ||
        hostname === 'team.aussie-dev.com.au.local') {
        return Brand.Aussie;
    }
    // default to customer
    return Brand.Lendi;
}
//# sourceMappingURL=getBrandFromHostname.js.map